import { render } from "./PoolInstructionView.vue?vue&type=template&id=764fc370&scoped=true"
import script from "./PoolInstructionView.vue?vue&type=script&lang=js"
export * from "./PoolInstructionView.vue?vue&type=script&lang=js"

import "./PoolInstructionView.vue?vue&type=style&index=0&id=764fc370&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-764fc370"]])

export default __exports__